// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryMutateHook on POST /chat/member-timeout-clear.

import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  typeChatMemberTimeoutClearBody,
  typeChatMemberTimeoutClearOutput200,
} from "../../sdk/chat/postChatMemberTimeoutClear";
import useCallSdk from "../../sdk-helpers/useCallSdk";

type Options = Omit<
  UseMutationOptions<
    typeChatMemberTimeoutClearOutput200,
    unknown,
    typeChatMemberTimeoutClearBody,
    unknown
  >,
  "mutationFn"
>;

let invalidationTimer: ReturnType<typeof setTimeout> | null = null;

// 150ms of silence before invalidating: a burst of mutations (a row action
// repeated across a table selection) triggers one refetch, not one per call.
export function invalidateRelated({
  queryClient,
}: {
  queryClient: QueryClient;
}): void {
  if (invalidationTimer) {
    clearTimeout(invalidationTimer);
  }
  invalidationTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: ["post:chat:chatListMembers", "svc:messaging-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:chat:chatGet", "svc:messaging-api"],
    });
  }, 150);
}

export default function useChatMemberTimeoutClear(options?: Options) {
  const { callSdk } = useCallSdk();
  const queryClient = useQueryClient();
  const resolvedOptions = options ?? {};

  return useMutation({
    mutationFn: callSdk().postChatMemberTimeoutClear,
    ...resolvedOptions,
    // TanStack Query v5 hands onSuccess four arguments
    // (data, variables, onMutateResult, context). Forward all four. Dropping
    // the last one makes the caller's own onSuccess a type error at every
    // generated mutation hook.
    onSuccess: (data, variables, onMutateResult, context) => {
      resolvedOptions.onSuccess?.(data, variables, onMutateResult, context);
      invalidateRelated({ queryClient });
    },
  });
}
